import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  UserSubscription,
  UserSubscriptionCategory,
  UserSubscriptionType
} from "../user/user-subscription";
import {DialogService} from "../../ng2-bootstrap-modal/dialog.service";
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import {Observable} from 'rxjs';
import {AuthService} from "../auth/auth.service";
import {ActivityStatus, IActivity} from "../activities/activity";
import {DbResponse} from "../shared/interceptors/db-response";
import {Website} from "../websites/website/website";
import {map} from "rxjs";
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {UserSubscriptionStatus} from "../user/user-subscription-status";
import {NotifierComponent} from "../shared/components/notifier/notifier.component";
import {Notification} from "../shared/components/notifier/notification";
import {NotificationType} from "../shared/components/notifier/notification-type";
import {WorkspaceService} from "../workspace/workspace.service";
import {TypeUtils} from "../shared/utils/type-utils";
import {filter, first} from "rxjs/operators";


@Component({
    selector: 'db-paypal-waiting',
    templateUrl: './paypal-waiting.component.html',
    styleUrls: ['./paypal-waiting.component.scss'],
    standalone: false
})
export class PaypalWaitingComponent implements OnInit {

  public fromPaypalRecurring: boolean;
  public fromUpgradedAccount: boolean;
  public fromNewPaymentMethod: boolean;
  public fromAdditional: boolean;
  public ongoingActivity$: Observable<IActivity[]>;
  public exceededDomains$: Observable<boolean>;
  public subscription: UserSubscription;
  public exceededDomain: boolean = false;
  public userSubscriptionStatus: any;
  public subscriptionId: number = null;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _dialogService: DialogService,
    private _authService: AuthService,
    private _workspaceService: WorkspaceService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _store: Store<fromStore.DbStoreState>
  ) {
  }

  ngOnInit() {
    this.subscription = this._route.snapshot.data['subscription'];
    this.fromPaypalRecurring = (window.location.href.indexOf("token") > -1);
    this.userSubscriptionStatus = UserSubscriptionStatus;
    if (!!localStorage.getItem('dbCheckoutSubscriptionId')) {
      this.subscriptionId = parseInt(localStorage.getItem('dbCheckoutSubscriptionId'), 10);
    }

    if (this.fromPaypalRecurring) {
      localStorage.setItem('dbloginFromSandbox', 'paypal_recurring');
      const paypalToken = new URL(window.location.href).searchParams.get("token");
      this.createPaypalExecuteAgreement(paypalToken);
    }
    this.fromNewPaymentMethod = localStorage.getItem('dbPaypalAccount') !== null;
    this.fromAdditional = !!localStorage.getItem('dbFromAdditional');
    this.fromUpgradedAccount = window.location.href.indexOf("upgraded_account") > -1
      || (this.subscription.type !== UserSubscriptionCategory.REGISTERED
        && this.subscription.category !== UserSubscriptionCategory.ENTERPRISE
        && !this.subscription.recharge);
    this.exceededDomains$ = this._store.select(fromStore.getActiveConnectedWebsites)
      .pipe(
        map((activeWebsites: Website[]): boolean => {
          this.exceededDomain = (activeWebsites.length >= this.subscription.plan.domainCount);
          return activeWebsites.length >= this.subscription.plan.domainCount;
        })
      );

    this.ongoingActivity$ = this._store.select(fromStore.getOngoingActivities);
    this.ongoingActivity$
      .subscribe((data): void => {
        const finishedAction = data && data.length && data.find(action => action.status === ActivityStatus.DONE && (action.action === "paypal_recurring_initial_payment_failed" || action.action === "paypal_recurring_initial_payment_success" || action.action === "paypal_recurring_new_profile_created_without_payment"));
        if (TypeUtils.isDefined(finishedAction) && TypeUtils.isDefined(finishedAction.action)) {
          if (finishedAction.action === "paypal_recurring_initial_payment_failed") {
            localStorage.removeItem('dbloginFromSandbox');
            this._router.navigate(['/checkout'], {
              queryParams: {
              from_paypalrecurring: 1,
              subscr_id: this.subscriptionId
              }
            });
          }
          if (finishedAction.action === "paypal_recurring_initial_payment_success" || finishedAction.action === "paypal_recurring_new_profile_created_without_payment") {
            this._getNewSubscriptionPlanAndOverPaypal();
          }
        }
      });

    setInterval(() => {
      if (localStorage.getItem('dbloginFromSandbox')) {
        this._authService.checkPaypalRecurringPayment()
          .pipe(filter((response: DbResponse): boolean => !!response),
          first())
          .subscribe((response) => {

            if (response.success) {
              if (response.data.status === "failed") {
                localStorage.removeItem('dbloginFromSandbox');
                localStorage.removeItem('dbFromPeriodCycleChange');
                this._router.navigate(['/checkout'],
                  {
                    queryParams: {
                      from_paypalrecurring: 1,
                      subscr_id: this.subscriptionId
                    }
                  });
              }
              if (response.data.status === "done") {
                this._getNewSubscriptionPlanAndOverPaypal();
              }
            }
          });
      }
    }, 15000);

  }

  private _getNewSubscriptionPlanAndOverPaypal(): void {
    this._workspaceService.getUserSubscription()
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response) => {
        if (response.success) {
          this.paypalWaitingIsOver(response.data);
        }
      });
  }

  get fromSandbox(): any {
    return localStorage.getItem('dbloginFromSandbox');
  }

  public createPaypalExecuteAgreement(paypalToken: any): void {
    this._authService.createPaypalExecuteAgreement(paypalToken)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response) => {
        if (!response.success) {
          localStorage.removeItem('dbloginFromSandbox');
          localStorage.removeItem('upgradeFromAi');
          this._router.navigate(['/checkout'],
            {
              queryParams: {
                from_paypalrecurring: 1,
                subscr_id: this.subscriptionId
              }
            });
        }
      });
  }

  public paypalWaitingIsOver(subscription?: any): void {
    if (subscription.status === this.userSubscriptionStatus.canceled || this.subscription.status === this.userSubscriptionStatus.canceled) {
      this._workspaceService.activateSubscription(this.subscription)
        .pipe(filter((activateResponse: DbResponse): boolean => !!activateResponse),
        first())
        .subscribe((activateResponse: DbResponse): void => {
          if (activateResponse.success) {
            this.paypalPaymentSteps(subscription);
          } else {
            NotifierComponent.notify(new Notification(activateResponse.message, NotificationType.DANGER));
            localStorage.removeItem('upgradeFromAi');
          }
        });
    } else {
      this.paypalPaymentSteps(subscription);
    }
  }

  public paypalPaymentSteps(subscription?: any): void {
    const route = '/websites';
    if (localStorage.getItem('switchPlanAnnual')) {
      window.location.href = window.location.origin + route + `?switch_plan=1`;
    }
    else if (this.subscription.recharge || ((this.subscription.status === this.userSubscriptionStatus.expired || this.subscription.status === this.userSubscriptionStatus.failed || this.subscription.isExpired) && !this.subscription.recharge)) {
      window.location.href = window.location.origin + "/workspace/subscription-plan";
    } else if (this.fromUpgradedAccount && !this.fromAdditional) {
      localStorage.removeItem('dbloginFromSandbox');
      localStorage.removeItem('dbPaypalAccount');
      if (this.fromNewPaymentMethod) {
        window.location.href = window.location.origin + "/workspace/payment-methods";
      } else {
        if (this.subscription.boosterProClient || this.subscription.trialBoosterClient) {
          this.sentSuccessCheckoutEvent('Booster Upgrade Offer');
          window.location.href = window.location.origin + route + `?upgraded_account=1&upgraded_from_trial=${this.subscription.category === UserSubscriptionCategory.STARTER}&upgraded_from_booster=${this.subscription.trialBoosterClient}`;
          localStorage.removeItem('upgradeFromAi');
        }
        else if (localStorage.getItem('dbFrom1MFPopupPaypal')) {
          this.sentSuccessCheckoutEvent('Free Upgrade Offer');
          localStorage.removeItem('dbFrom1MFPopupPaypal');
          window.location.href = window.location.origin + route + `?upgraded_account=1&upgraded_from_trial=${this.subscription.category === UserSubscriptionCategory.STARTER}&upgraded_from_booster=${this.subscription.trialBoosterClient}`;
          localStorage.removeItem('upgradeFromAi');
        } else if (localStorage.getItem('dbFromBoosterPopupPaypal')) {
          this.sentSuccessCheckoutEvent('Booster Upgrade Offer');
          localStorage.removeItem('dbFromBoosterPopupPaypal');
          window.location.href = window.location.origin + route + `?upgraded_account=1&upgraded_from_trial=${this.subscription.category === UserSubscriptionCategory.STARTER}&upgraded_from_booster=${this.subscription.trialBoosterClient}`;
          localStorage.removeItem('upgradeFromAi');
        } else if (localStorage.getItem('dbFromPeriodCycleChange')) {
          localStorage.removeItem('dbloginFromSandbox');
          localStorage.removeItem('dbFromPeriodCycleChange');
          window.location.href = window.location.origin + route + `?switch_cycle=1`;
        }
        else {
          this.sentSuccessCheckoutEvent('SSH Upgrade from 1wf');
          window.location.href = window.location.origin + route + `?upgraded_account=1&upgraded_from_trial=${this.subscription.category === UserSubscriptionCategory.STARTER}&upgraded_from_booster=${this.subscription.trialBoosterClient}`;
        }
      }
    } else if ((subscription && (subscription.subscription_category === UserSubscriptionType.PLATFORM || subscription.subscription_category === UserSubscriptionCategory.BOOSTER) && !this.fromAdditional) || this.exceededDomain) {
      localStorage.removeItem('dbloginFromSandbox');
      window.location.href = window.location.origin + route;
    }  else if (subscription && subscription.subscription_category === UserSubscriptionType.ONE_PRODUCT) {
      localStorage.removeItem('dbloginFromSandbox');
      window.location.href = window.location.origin + "/add-website";
    } else if (this.fromAdditional) {
      const getFromLocal = localStorage.getItem('dbFromAdditional');
      const getFromLocalCdn = localStorage.getItem('dbFromAdditionalCdn');
      if (!TypeUtils.isNull(getFromLocal) && !TypeUtils.isNull(getFromLocalCdn)) {
        const getAdditionalCount = parseInt(getFromLocal, 10);
        const getAdditionalCdnCount = parseInt(getFromLocalCdn, 10);
        window.location.href = window.location.origin + "/websites?additonal_website=" + getAdditionalCount + "&additonal_cdn=" + getAdditionalCdnCount;
      }
      else if (TypeUtils.isNull(getFromLocal) && !TypeUtils.isNull(getFromLocalCdn)) {
        const getAdditionalCdnCount = parseInt(getFromLocalCdn, 10);
        window.location.href = window.location.origin + "/websites?additonal_cdn=" + getAdditionalCdnCount;
      }
      else {
        const getAdditionalCount = parseInt(getFromLocal, 10);
        window.location.href = window.location.origin + "/websites?additonal_website=" + getAdditionalCount;
      }

    } else if (this.fromNewPaymentMethod) {
      window.location.href = window.location.origin + "/workspace/payment-methods";
    } else {
      window.location.href = window.location.origin + "/add-website";
    }
  }

  private sentSuccessCheckoutEvent(category: string): void {
    const analyticsData = {
      eventCategory: category,
      eventAction: 'Checkout Page',
      eventLabel: 'Checkout Completed'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }
}
